module.exports = __webpack_public_path__ + "img/logo-small.200e26ad.png";